// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__cFnJY","link":"nav_link__HzVha","icon":"nav_icon__gu7kL","text":"nav_text__ZvzGF"};